<template>
  <div class="header-container">
    <div class="headers" v-if="clientWidth > 900">
      <el-row class="headers_body">
        <el-col :span="4">
          <div class="headers_body_logo" @click="goHome">
            <img src="@/assets/img/home/logo.png" alt="" />
          </div>
        </el-col>
        <el-col :span="16">
          <div
            class="headers_body_main"
            @mouseover.prevent="showToggle"
            @mouseleave="hiddenToggle"
          >
            <div class="nav">
              <div class="nav_item" v-for="(item, index) in nav" :key="index">
                <div class="nav_item_title" @click="routeTo(item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <transition name="draw">
              <div class="subMenu" v-show="show">
                <el-row>
                  <el-col :span="16" :offset="4">
                    <div class="nav">
                      <div
                        class="nav_item_tiny"
                        v-for="(item, index) in nav"
                        :key="index"
                      >
                        <div
                          class="tiny"
                          v-for="(it, ind) in item.child"
                          :key="ind"
                          @click="childRouteTo(it)"
                        >
                          <p>{{ it.name }}</p>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4"></el-col>
                </el-row>
              </div>
            </transition>
            <transition name="line">
              <div class="line" v-if="show"></div>
            </transition>
          </div>
        </el-col>
        <el-col :span="4" v-if="userInfo">
          <div class="user">
            <div
              class="userInfo"
              @mouseover="showDetails"
              @mouseleave="hiddenDetail"
            >
              <span>{{ userInfo.nickname }}</span>

              <div class="user-detail user-detail-mobile" v-if="showDetail">
                <div class="light"></div>
                <div class="links-container">
                  <div @click="goto(`${accountBase}/#/mypage/userdata?ctab=0`)">
                    {{ $t("我的資料") }}
                  </div>
                  <div @click="goto(`${accountBase}/#/mypage/userdata?ctab=1`)">
                    {{ $t("密碼更改") }}
                  </div>
                </div>
                <div class="points-container">
                  <div>
                    {{ $t(`我的點数：`) }}{{ userInfo.total_point }}
                    <i
                      :title="
                        $t(
                          '玩家必須先儲值點數，方可在 購買元寶 頁面購買新墨魂Online的元寶'
                        )
                      "
                      >?</i
                    >
                  </div>
                  <div>
                    <div>{{ $t("購買P-point後") }}</div>
                    <div>{{ $t("商城→購買元寶") }}</div>
                  </div>
                  <div @click="routeTo({ path: '/mall' })">
                    {{ $t("儲值點數") }}
                  </div>
                </div>
              </div>
            </div>

            <div class="login" @click="logouts">
              <img src="@/assets/img/header/icon_signin.png" alt="" />
              {{ $t("登出") }}
            </div>
          </div>
        </el-col>
        <el-col :span="4" v-else>
          <div class="user">
            <div class="signUp" @click="signup">
              <img src="@/assets/img/header/icon_signup.png" alt="" />
              {{ $t("會員註冊") }}
            </div>
            <div class="login" @click="login">
              <img src="@/assets/img/header/icon_signin.png" alt="" />
              {{ $t("登入") }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="mobile-header" v-else>
      <div class="mobile-header-nav">
        <div class="m-menu" @click="showMobileMenu">
          <img src="@/assets/img/header/menu.png" alt="" />
        </div>
        <div class="m-logo" @click="goHome">
          <img src="@/assets/img/home/logo.png" alt="" />
        </div>
        <div class="m-user" @click="mobileLogin">
          <img src="@/assets/img/header/icon_signup.png" alt="" />
        </div>
      </div>

      <div class="mobile-nav" v-if="showMobileToggle">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item
            :title="item.name"
            :name="index"
            v-for="(item, index) in nav"
            :key="index"
          >
            <div
              class="mobile-tiny-nav"
              v-for="(item, index) in item.child"
              :key="index"
              @click="childRouteTo(item)"
            >
              {{ item.name }}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Cookie from "js-cookie";
import { logout, getUserInfo } from "@/api/login";
import paccount from "@/utils/paccount";
export default {
  data() {
    return {
      show: false,
      userInfo: null,
      showUserInfo: false,
      showDetail: false,
      activeName: null,
      showMobileToggle: false,
      accountBase: paccount.accountBase,
    };
  },
  computed: {
    ...mapState({
      nav: (state) => state.header.nav,
      isFixed: (state) => state.header.isFixed,
      clientWidth: (state) => state.screen.clientWidth,
    }),
  },
  mounted() {
    this.getUserInfos();
  },
  methods: {
    showDetails() {
      this.showDetail = true;
    },
    hiddenDetail() {
      this.showDetail = false;
    },
    async getUserInfos() {
      try {
        const res = await getUserInfo();
        this.userInfo = res.data;
      } catch (e) {
        if (e.response.status === 404) {
          // 登录失效
        }
      }
    },
    signup() {
      window.localStorage.setItem("return_url", this.$route.fullPath);
      let href =
        this.$store.state.header.app_oauth2 +
        `/#/register?client_id=${this.$store.state.header.app_account_client_id}&return_url=${this.$store.state.header.app_redirect_url}`;
      if (this.$route.query.utm_source)
        href = `${href}&utm_source=${this.$route.query.utm_source}`;
      if (this.$route.query.utm_campaign)
        href = `${href}&utm_campaign=${this.$route.query.utm_campaign}`;
      if (this.$route.query.utm_medium)
        href = `${href}&utm_medium=${this.$route.query.utm_medium}`;
      location.href = href;
    },
    login() {
      window.localStorage.setItem("return_url", this.$route.fullPath);
      location.href =
        this.$store.state.header.app_oauth2 +
        `/#/login?client_id=${this.$store.state.header.app_account_client_id}&return_url=${this.$store.state.header.app_redirect_url}`;
    },
    goHome() {
      this.$router.push("/home");
    },
    async logouts() {
      const res = await logout();
      if (res.status === 200) {
        this.$message.success(this.$t("登出成功"));
        this.userInfo = null;
        Cookie.remove("token");
        Cookie.remove("userInfo");
        this.$router.push("/home");
      }
    },
    routeTo(item) {
      this.$router.push(`${item.path}`);
    },
    childRouteTo(item) {
      this.$router.push(`${item.path}`);
      this.$store.commit("SET_CURRENTTYPE", item.type);
      this.showMobileMenu();
    },
    showToggle() {
      this.show = true;
    },
    hiddenToggle() {
      this.show = false;
    },
    mobileLogin() {
      if (Cookie.get("token")) {
        let token = Cookie.get("token");
        let url = `${paccount.accountBase}/#/mypage/userdata?`;
        if (this.$route.query.tab == 1)
          url = `${paccount.accountBase}/#/mypage/userdata?ctab=1&`;
        window.location.href = url + "token=" + token;
      } else {
        this.login();
      }
    },
    goto(url) {
      let token = Cookie.get("token");
      if (token) {
        window.location.href = url + "&token=" + token;
      } else {
        this.login();
      }
    },
    showMobileMenu() {
      this.showMobileToggle = !this.showMobileToggle;
    },
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  @media only screen and (max-width: 900px) {
    width: 100%;
  }
  .headers {
    width: 100%;
    height: 100px;
    background-image: url("~@/assets/img/header/bg_nav.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition: height 1s ease;
    &_body {
      //max-width: 1920px;
      &_logo {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .line {
        position: fixed;
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 1px;
        z-index: 1000;
        background-color: #fff;
        transition: width 0.5s linear;
        will-change: transform;
      }
      .line-enter-active,
      .line-leave-to {
        width: 0;
      }
      &_main {
        position: relative;
        .nav {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          text-align: center;
          margin-left: 2rem;
          &_item {
            width: 200px;
            font-size: 16px;
            text-align: center;
            color: #fff;
            text-align: center;
            border: none;
            &_title {
              width: fit-content;
              height: 97px;
              line-height: normal;
              border-bottom: 3px solid transparent;
              cursor: pointer;
              text-align: left;
              display: flex;
              align-items: center;
              &:hover {
                border-bottom: 3px solid #ddb556;
              }
            }
          }
        }
        .subMenu {
          position: fixed;
          left: 0;
          top: 100px;
          color: #fff;
          background-image: url("~@/assets/img/header/bg_nav.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;

          width: 100%;
          font-size: 16px;
          .nav {
            display: flex;

            align-items: flex-start;
            &_item_tiny {
              width: 200px;
              font-size: 16px;
              border: none;
              height: auto;
              .tiny {
                text-align: center;
                margin: 20px 0;
                cursor: pointer;
                text-align: left;
                &:hover {
                  color: #c6a86c;
                }
              }
            }
          }
        }
      }
      .user {
        display: flex;
        align-items: center;
        height: 100px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        .signUp {
          flex: 1;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid #fff;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-right: 1px solid #fff;
            padding-right: 20px;
            &:hover {
              color: #ddb556;
            }
          }

          img {
            width: 20px;
            height: 20px;
            margin-right: 0.52vw;
          }
        }
        .userInfo {
          width: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          height: 100px;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-right: 1px solid #fff;
            padding-right: 20px;
            &:hover {
              color: #ddb556;
            }
          }

          img {
            width: 20px;
            height: 20px;
            margin-right: 0.52vw;
          }
        }
        .login {
          flex: 1;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20px;
            height: 20px;
            margin-right: 0.52vw;
          }
        }
      }
    }
  }
  .mobile-header {
    width: 100%;
    height: 200px;
    background-color: rgba($color: #000000, $alpha: 0.8);
    @media only screen and (max-width: 900px) {
      height: 50px;
    }
    &-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // background-image: url("~@/assets/img/header/bg_nav.png");
      height: 100%;
      box-sizing: border-box;
      @media only screen and (max-width: 900px) {
        padding: 0 5%;
      }
      .m-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        img {
          width: 30%;
        }
      }
    }
    .mobile-nav {
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
}

.draw-enter-active {
  transition: all 0.5s linear;
  will-change: transform;
  height: 0;
  overflow: hidden;
}
.draw-leave-active {
  transition: all 0.5s linear;
  will-change: transform;
  height: 0;
  overflow: hidden;
}
.draw-enter {
  height: 0;
}
.draw-enter-to {
  height: 150px;
}
.draw-leave {
  height: 150px;
}
.draw-leave-to {
  height: 0px;
}
.user-detail {
  background-image: url("~@/assets/img/header/bg_nav.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: fixed;
  height: 205px;
  opacity: 0.96;
  border-image: -webkit-linear-gradient(to left, #2b2a28, #c6a86c, #2b2a28) 8 10
    8;
  border-image: -moz-linear-gradient(to left, #2b2a28, #c6a86c, #2b2a28) 8 10 8;
  border-image: linear-gradient(to left, #2b2a28, #c6a86c, #2b2a28) 8 10 8;
  overflow: hidden;
  font-size: 14px;
  text-align: left;
  position: absolute;
  bottom: -206px;
  left: 0;
}

.user-detail > div {
  padding-left: 20px;
}

.light {
  width: 177px;
  height: 14px;
}

.links-container {
  border-bottom: 1px solid #fff;
}

.links-container > div {
  padding-bottom: 17px;
  cursor: pointer;
}

.points-container > div:nth-child(2) {
  font-size: 12px;
  opacity: 0.59;
  line-height: 15px;
}

.points-container > div:first-child {
  margin: 10px 0;
}

.points-container > div:last-child {
  margin: 10px 0;
  padding: 0 5px;
  height: 21px;
  text-align: center;
  border: 1px solid #a3a3a3;
  cursor: pointer;
}

.points-container i {
  width: 16px;
  height: 16px;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 8px;
  font-size: 12px;
  display: inline-block;
  text-align: center;
  margin: 0 20px;
}

.cursor {
  cursor: pointer;
}
.cursor:hover {
  color: #c6a86c;
}
::v-deep .el-collapse-item__header {
  padding: 0 5%;
  text-align: center;
  color: #fff;
  background-color: transparent;
  @media screen and (max-width: 900px) {
    font-size: 12px;
    height: 37px;
    line-height: 37px;
  }
}
::v-deep .el-collapse-item__wrap {
  background: transparent;
}
::v-deep .el-collapse-item__content {
  background-color: none;
  color: #fff;
  @media screen and (max-width: 900px) {
    font-size: 12px;
    padding-bottom: 0;
  }
}
.mobile-tiny-nav {
  padding: 1vh 0;
  border-top: 1px solid #fff;
  @media screen and (max-width: 900px) {
    font-size: 12px;
  }
}
</style>
